<template>
  <div class="artwork-list-box">
    <!-- 艺术品列表页 -->
    <div class="the-body-box">
      <div class="banner-category-box">
        <img :src="bannerImg" alt="" class="bg-img" />
        <div class="category-list-box clearfix">
          <div class="catetory-left-box category-box f-l">
            <div
              class="first-class-item"
              v-for="(item, i) in categoryList"
              :key="i"
              @mouseenter="loadCategory(item)"
              @mouseleave="loadCategory(null)"
              @click="changeBanner(item, 1)"
            >
              <div class="banner-change">
                <span class="name">{{ filterName(item) }}</span>
                <span class="el-icon-arrow-right text-light-gray icons"></span>
              </div>
            </div>
          </div>
          <div
            class="category-right-box category-box f-l"
            :class="isShow ? 'active' : ''"
            @mouseover="isShow = true"
            @mouseleave="isShow = false"
          >
            <div class="clearfix">
              <div
                class="second-class-item"
                v-for="(item, i) in categoryListChild"
                :key="i"
              >
                <div @click="changeBanner(item, 2)">
                  <!-- <img :src="item.kindPath" alt="" class="category-img" /> -->
                  <div class="name text-center">
                    {{ filterName(item) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="artwork-list-content" id="artworkBox">
        <el-row :gutter="24" style="margin: 0">
          <el-col
            :span="24"
            v-loading="loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            style="min-height: 650PX;padding: 0"
            class="common-loading-class"
          >
            <div class="photo-wrap">
              <div @click="handlePreview(index)" class="photo-item" v-for="(item, index) in photoArr" :key="index">
                <div class="p-img">
                  <img :src="item.albumUrl" alt="">
                </div>
                <p class="p-desc ellipsis-two">{{ filterDesc(item) }}</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 音乐 -->
    <div @click="handleControl" class="music-wrap">
      <img :class="{'play': isPlay }" :src="isPlay ? musicON : musicOFF" alt="">
      <audio loop preload="auto" id="webAudio" autoplay="autoplay">
        <source src="https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/bgmusic.mp3" type="audio/mpeg" />
      </audio>
    </div>

    <!-- 弹窗轮播图 -->
    <div class="modal-fixed" v-if="showModal">
      <div class="cont" @click="showModal = false">
        <el-carousel indicator-position="none" :initial-index="IndexModal" :autoplay="false" arrow="always">
          <el-carousel-item v-for="(item, index) in photoArr" :key="index">
            <div class="item-cont">
              <img @click.stop="showModal = true" :src="item.albumUrl" alt="">
              <p>{{ filterDesc(item) }}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

  </div>
</template>
<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-7CH9447NP2"></script>
<script>
export default {
  components: {
  },
  data() {
    return {
      musicON: `https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/music_on.png?t=${new Date().getTime()}`,
      musicOFF: `https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/music_off.png?t=${new Date().getTime()}`,
      isPlay: true,
      bannerImg: `https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/banner_activity.jpg?t=${new Date().getTime()}`,
      loading: false,
      isShow: false,
      categoryList: [],
      categoryListChild: [],
      showModal: false,
      photoArr: [],
      query: {
        classifyId2: '',
        classifyId1: ''
      },
      IndexModal: 0
    };
  },
  created() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());

    gtag("config", "G-7CH9447NP2");
  },

  computed: {
    filterName () {
      return (item) => {
        const locale = this.$store.state.locale
        const str = locale === 'en' ? item.classifyNameEn : item.classifyNameCn
        return str
      }
    },
    filterDesc () {
      return (item) => {
        const locale = this.$store.state.locale
        const str = locale === 'en' ? item.albumNameEn : item.albumNameCn
        return str
      }
    }
  },
  methods: {
    handlePreview (index) {
      this.IndexModal = index
      this.showModal = true
    },
    handleControl () {
      const doms = document.getElementById('webAudio')
      this.isPlay ? doms.pause() : doms.play()
      this.isPlay = !this.isPlay
    },
    audioAutoPlay () {
      console.log('auto play')
      let audio = document.getElementById('webAudio');
      this.isPlay = true;
      audio.play();
      document.removeEventListener('touchstart', this.audioAutoPlay);
    },

    loadCategory(item) {
      if (item != null) {
        this.categoryListChild = item.classifyList;
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },

    changeBanner(item, type) {
      if (type === 1) {
        this.query.classifyId1 = item.classifyId
        this.query.classifyId2 = ''
      }
      if (type === 2) {
        this.query.classifyId1 = item.parentId
        this.query.classifyId2 = item.classifyId
      }
      this.fetchPhotoList(1);
      window.location.href = '#artworkBox'
    },

    // 相册分类
    fetchPhotoCategory() {
      this.$commonPromise("get", this.$Api.photoCategory).then((res) => {
        if (res.code === 200) {
          this.categoryList = res.data;
        }
      });
    },

    // 相册列表
    fetchPhotoList() {
      this.loading = true
      this.$commonPromise("get", this.$Api.photoList, this.query).then((res) => {
        if (res.code === 200) {
          this.photoArr = res.data;
        }
        this.loading = false
      });
    },

  },
  watch: {
  },
  mounted() {
    this.fetchPhotoCategory()
    this.fetchPhotoList()

    // 自动播放音乐效果，解决微信自动播放问题
    document.addEventListener('touchstart',this.audioAutoPlay,false);
    document.addEventListener('WeixinJSBridgeReady', this.audioAutoPlay,false);
    let oAudio = document.querySelector("#webAudio");
    oAudio.onended = function () {//播放完毕，重新循环播放
      oAudio.load();
      oAudio.play();
    }
  },
};
</script>
<style lang="scss" scoped>
.music-wrap {
  position: fixed;
  right: 10%;
  bottom: 10%;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
    &.play {
      animation: rotate 10s linear infinite;
    }
  }
}
@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
.modal-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba($color: #000000, $alpha: .8);
  display: flex;
  justify-content: center;
  align-items: center;
  .cont {
    height: 100%;
    width: 100%;
    .el-carousel {
      width: 100%;
      height: 100%;
      /deep/ .el-carousel__container {
        height: 100%;
        .el-carousel__item {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          .item-cont {
            img {
              max-width: 85%;
              max-height: 85%;
              display: block;
              width: auto;
              height: auto;
              margin: 0 auto;
            }
            p {
              color: #fff;
              text-align: center;
              padding: 0 20PX;
              font-size: 18PX;
              font-weight: bold;
              margin-top: 30PX;
            }
          }
        }
        .el-carousel__arrow {
          background: rgba(135, 135, 135, .5);
          &:hover {
            background: #409eff;
          }
        }
      }
    }
  }
}
.artwork-list-box {
  .banner-category-box {
    position: relative;
    height: 500PX;
    width: 100%;
    // background-image: url('../../../../assets/img/banner.png');
    // background-size: 100% 100%;
    .bg-img {
      width: 100%;
      height: 100%;
    }
    .category-list-box {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      .category-box {
        // height: 580PX;
        height: 500PX;
        overflow-y: auto;
        background-color: rgba(#000, 0.4);
        -ms-overflow-style: none; /*隐藏滚动条，当IE下溢出，仍然可以滚动*/
        &::-webkit-scrollbar {
          display: none;
        }
      }
      .catetory-left-box {
        width: 280PX;
        .first-class-item {
          position: relative;
          .banner-change {
            display: block;
            padding: 29PX 32PX 29PX 20PX;
            cursor: pointer;
          }
          &:not(:last-child) {
            border-bottom: 1PX solid rgba(#fff, 0.6);
          }
          .name {
            color: #fff;
            font-size: 16PX;
          }
          .icons {
            position: absolute;
            right: 16PX;
            top: 30PX;
          }
          &:hover {
            .name,
            .icons {
              color: $main-color;
            }
          }
        }
      }
      .category-right-box {
        display: none;
        // width: 1020PX;
        padding: 20PX 60PX 20PX 40PX;
        &.active {
          display: block;
        }
        .second-class-item {
          // width: 180PX;
          // margin-right: 20PX;
          .category-img {
            width: 180PX;
            height: 116PX;
          }
          .name {
            padding: 11PX 4PX 20PX;
            font-size: 16PX;
            color: #fff;
            cursor: pointer;
            &:hover {
              color: #FBC02D;
            }
          }
        }
      }
    }
  }
  .artwork-list-content {
    margin-top: 30PX;
    padding: 20PX 0 0;
    border-top: 1PX solid #ddd;
    // .artwork-search-input {
    //   padding-left: 24PX!important;
    //   padding-right: 0!important;
    // }
    .artwork-filters-box {
      margin-top: 24PX;
      .lbl-box {
        padding: 20PX 0;
        border-top: 1PX solid #ddd;
      }
    }
    .artwork-filters-collapse {
      .price-box {
        padding: 0 14PX;
      }
      .space-box {
        line-height: 2;
      }
      .shape-box {
        .iconfont {
          display: inline-block;
          zoom: 1;
          width: 45PX;
          color: $text-light-gray;
          font-size: 20PX;
          &.active {
            color: $main-color;
          }
        }
      }
      .colors-box {
        display: inline-block;
        zoom: 1;
        margin: 0 auto;
        .color-item {
          width: 50PX;
          height: 10PX;
          margin-right: 1PX;
          border: 1PX solid transparent;
          &.active {
            border-color: #000;
          }
        }
        &.sizes-box {
          .color-item {
            background-color: #e6e6e6;
            &.active {
              background-color: $main-color;
              border-color: transparent;
            }
          }
        }
      }
      .sizes-text-box {
        // display: inline-block;
        // zoom: 1;
        padding-left: 10PX;
        margin: 0 auto;
        .text-item {
          font-size: 10PX;
          width: 45PX;
          line-height: 10PX;
        }
      }
    }
    .artwork-waterfall-list {
      position: relative;
      .artwork-card {
        position: absolute;
        .artwork-item {
          margin-top: 24PX;
          &:hover {
            box-shadow: 0 0 15PX 3PX rgba(#000, 0.2);
          }
          .art-img {
            width: 100%;
          }
          .text-box {
            padding: 13PX 8PX 10PX 13PX;
            .price {
              line-height: 19PX;
            }
            .txt {
              margin-bottom: 8PX;
              height: 17PX;
            }
          }
        }
      }
    }
  }
}
.photo-wrap {
  display: flex;
  flex-wrap: wrap;
  .photo-item {
    width: 285PX;
    height: 350PX;
    margin-right: 20PX;
    margin-bottom: 10PX;
    cursor: pointer;
    &:hover .p-img img {
      transform: scale(1.05);
    }
    &:nth-child(4n) {
      margin-right: 0;
    }
    .p-img {
      width: 100%;
      height: 285PX;
      overflow: hidden;
      border-radius: 4PX;
      img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
        transition: all 400ms;
      }
    }
    p {
      height: 45PX;
      font-size: 14PX;
      line-height: 20PX;
      padding-top: 6PX;
      color: #666;
    }
  }
}

.artwork-img-box {
  position: relative;

  h5 {
    width: 100PX;
    height: 100PX;
    border-radius: 50%;
    text-align: center;
    line-height: 100PX;
    color: #fff;
    font-size: 14PX;
    transform: rotate(45deg);
    background-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 2PX 4PX rgba(0, 0, 0, 0.12), 0 0 6PX rgba(0, 0, 0, 0.04);
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }
}
</style>
